export default __webpack_public_path__ + "static/checknlearn-promo@3x-a81244a1026ff38a1c8176fa7d69b0ea.webp";